/* eslint-disable react/prop-types */
import React, {
  memo,
  forwardRef,
  useRef,
  useState,
  useEffect,
  useImperativeHandle,
  Fragment,
} from 'react';
import { GoogleMap, Marker } from '@react-google-maps/api';
import event from '~helpers/mixpanel';
import { MapMarker } from 'common/components/svgs';
import { pageType } from '~constants/pages';

const Map = memo(
  forwardRef(
    (
      { mapZoom, setMapZoom, center, position, setCenter, changePosition, propertyTypeSlug },
      ref,
    ) => {
      const [map, setMap] = useState(null);

      const cityCenterRef = useRef(null);

      useImperativeHandle(ref, () => ({
        mapInstance: map,
        defaultCenter: cityCenterRef.current,
      }));

      const handleMapLoad = async map => {
        setMap(map);

        const service = new window.google.maps.places.PlacesService(map);
        const countryCode = window.hurricane.clientInfo?.country;

        if (countryCode) {
          service.findPlaceFromQuery(
            {
              query: countryCode + ' city',
              fields: ['ALL'],
            },
            (result, status) => {
              if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                const location = result[0]?.geometry?.location?.toJSON();

                cityCenterRef.current = location;

                setCenter(location);
              }
            },
          );
        }
      };

      const handleMapUnMount = () => {
        setMap(null);
      };

      const handleZoomChanged = () => {
        if (map) {
          setMapZoom(map.zoom);
        }
      };

      const handleMapDragEnd = () => {
        event('Clicked OP Property Map Page', {
          'Drag Map Count': 'Yes',
          'Property Type': propertyTypeSlug,
          'Current Page Type': pageType.onBoardingPage,
        });
        if (map) {
          changePosition(map.getCenter()?.toJSON());
        }
      };

      useEffect(() => {
        if (map) {
          map.setZoom(mapZoom);
        }
      }, [map, mapZoom]);

      return (
        <Fragment>
          <GoogleMap
            id="map--container"
            mapContainerStyle={{
              width: 'calc(100% + 800px)',
              height: '100%',
            }}
            options={{
              center,
              zoom: mapZoom,
              zoomControl: true,
              zoomControlOptions: {
                position: window.google.maps.ControlPosition.LEFT_CENTER,
              },
              scrollwheel: false,
              disableDefaultUI: true,
            }}
            onLoad={handleMapLoad}
            onUnmount={handleMapUnMount}
            onZoomChanged={handleZoomChanged}
            onDragEnd={handleMapDragEnd}
          >
            <If condition={position.lat && position.lng}>
              <Marker position={position} opacity={0} />
              <MapMarker className="map--marker__icon" />
            </If>
          </GoogleMap>

          <div className="map--container__mask"></div>
        </Fragment>
      );
    },
  ),
);

Map.displayName = 'Map';

export default Map;
